import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { LoginService } from 'src/app/managers/login.service';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { Channel } from 'src/app/models/channel';
import { Category } from 'src/app/models/category';
import { environment } from 'src/environments/environment';
import { EditCategoryComponent } from 'src/app/components/edit-category/edit-category.component';
import { EditChannelComponent } from 'src/app/components/edit-channel/edit-channel.component';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { RssFeedService } from 'src/app/managers/rssFeed.service';
import { Store } from 'src/app/store/store';
import { ChannelActionType, channelReducer, DisplayModeActionType, displayModeReducer, SubscriptionDisplayModeActionType, subscriptionDisplayModeReducer } from 'src/app/store/reducers';

@Component({
  selector: 'app-side-channel-menu',
  templateUrl: './side-channel-menu.component.html',
  styleUrls: ['./side-channel-menu.component.css']
})
export class SideChannelMenuComponent extends BaseComponent implements OnChanges, OnInit, OnDestroy {
  @Input() loadInProgress: boolean;
  @Input() favoriteItemCount: number;
  defaultChannelImageUrl: string;
  subscriptionTitle: string;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, private _rssFeedManager: RssFeedService,
              private _snackBar: MatSnackBar, private _store: Store) { 
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      if (propName === 'dataSource') {
        this.updateSubscriptionTitle();
      }
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.defaultChannelImageUrl = environment.defaultChannelImageUrl;
    this.updateSubscriptionTitle();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  categoryClick(category: Category) {
    if (category.Channels !== null && category.Channels.length > 0)  
      this.toggleCategoryForChannels(category.Name);
  }

  channelClick(channel: Channel) {
    this._store.dispatch(channelReducer, { type: ChannelActionType.ChannelSelected, payload: channel });
  }

  todayFeedsClick() {
    this._store.dispatch(displayModeReducer, { type: DisplayModeActionType.Today });
  }

  bookmarksClick() {    
    if (this.isUserLogged())
      this._store.dispatch(displayModeReducer, { type: DisplayModeActionType.Favorite });
    else 
      this.openAlertDialog('UltraRSS', 'Please login to go to Bookmarks', '400', '300');
  }

  categoryMenuClick(menuAction: string) {
    if (!this.isUserLogged()) {
      this.openAlertDialog('UltraRSS', 'Please login to ' + menuAction.toLowerCase() + ' subscription group', '400', '300');
      return;
    }

    let heightValue: string;

    if (menuAction === 'Add')
      heightValue = '300px';
    else if (menuAction === 'Edit')
      heightValue = '375px';
    else
      heightValue = '225px';

    const dialogRef = this.dialog.open(EditCategoryComponent, {
      width: '550px',
      height: heightValue,
      data: {
        parentComponent: 'SideChannelMenuComponent',
        dataSource: this.dataSource,
        action: menuAction
      }
    });

    dialogRef.afterClosed().subscribe(updatedCategories => {
      if (updatedCategories !== null && updatedCategories.length > 0) {
        if (menuAction === 'Add')
          this.updateSourceForCategoryAdd(updatedCategories);
        else if (menuAction === 'Edit')
          this.updateSourceForCategoryEdit(updatedCategories);
        else
          this.updateSourceForCategoryRemove(updatedCategories);
      }
    });
  }

  channelMenuClick(menuAction: string) {    
    if (!this.isUserLogged()) {
      this.openAlertDialog('UltraRSS', 'Please login to ' + menuAction.toLowerCase() + ' subscription', '400', '300');
      return;
    }
    
    if (!this.categoryExist()) {
      this.openAlertDialog('UltraRSS', 'No group or subscription exist to ' + menuAction.toLowerCase(), '400', '300');
      return;
    }

    let heightValue: string;

    if (menuAction === 'Add')
      heightValue = '375px';
    else if (menuAction === 'Edit')
      heightValue = '375px';
    else
      heightValue = '225px';

    const dialogRef = this.dialog.open(EditChannelComponent, {
      width: '550px',
      height: heightValue,
      data: {
        parentComponent: 'SideChannelMenuComponent',
        dataSource: this.dataSource,
        action: menuAction
      }
    });

    dialogRef.afterClosed().subscribe(updatedChannels => {
      if (updatedChannels !== null && updatedChannels.length > 0) {
        if (menuAction === 'Add')
          this.updateSourceForChannelAdd(updatedChannels);
        else if (menuAction === 'Edit')
          this.updateSourceForChannelEdit(updatedChannels);
        else
          this.updateSourceForChannelRemove(updatedChannels);
      }
    });
  }

  subscriptionDisplayMode(mode) {    
    this._store.dispatch(subscriptionDisplayModeReducer, { type: (mode === 'grid' ? SubscriptionDisplayModeActionType.Grid : SubscriptionDisplayModeActionType.List) });
  }

  categoryExist(): boolean {
    return (this.dataSource !== undefined && this.dataSource.length > 0) ? true : false;
  }

  // isDefaultLoggedin(): boolean {
  //   return (this.getLoggedinUser().Email.toLowerCase() === environment.defaultEmail.toLowerCase());
  // }

  async refreshTodayFeedsAsync() {
    this._snackBar.open("Refreshing today's feeds...");
    let responseMsg = await this._rssFeedManager.refreshTodayFeedsAsync();
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open("Today's feeds have been successfully refreshed.", 'OK', { duration: this._successMsgDuration });
    }
    else
      this._snackBar.open("Failed to refresh today's feeds: " + responseMsg.Message, 'OK', { duration: this._failMsgDuration });
  }

  private updateSubscriptionTitle() {
    if (this.isUserLogged()) {
      this.subscriptionTitle = 'Your Subscriptions';
    }
    else {
      this.subscriptionTitle = 'Subscriptions';
    }
  }

  private updateSourceForCategoryEdit(updatedCategories: Category[]) {
    updatedCategories.map(update => {
      for (let index = 0; index < this.dataSource.length; index++) {
        let source = this.dataSource[index];

        if (source.Id === update.Id) {
          source.Name = update.Name;
          source.Description = update.Description;
        }
      }
    });

    this.dataSource.sort((a, b) => a.Name > b.Name ? 1 : -1);
  }

  private updateSourceForChannelEdit(updatedChannels: Channel[]) {
    updatedChannels.map(update => {
      this.dataSource.map(category => {
        category.Channels.map(source => {
          if (source.Id === update.Id) {
            source.Title = update.Title;
            source.ChannelUrl = update.ChannelUrl;
            category.Channels.sort((a, b) => a.Title > b.Title ? 1 : -1);
          }
        });
      });
    });
  }

  private updateSourceForCategoryAdd(updatedCategories: Category[]) {
    updatedCategories.map(update => {
      this.dataSource.push(update);
    });

    this.dataSource.sort((a, b) => a.Name > b.Name ? 1 : -1);
  }

  private updateSourceForChannelAdd(updatedChannels: Channel[]) {
    updatedChannels.map(update => {
      update.Categories.map(category => {
        this.dataSource.map(source => {
          if (source.Id === category.Id) {
            source.Channels.push(update);
            source.Channels.sort((a, b) => a.Title > b.Title ? 1 : -1);
          }
        });
      });
    });
  }

  private updateSourceForCategoryRemove(updatedCategories: Category[]) {
    updatedCategories.map(remove => {
      this.dataSource = this.dataSource.filter(c => c.Id !== remove.Id);
    });
  }

  private updateSourceForChannelRemove(updatedChannels: Channel[]) {
    updatedChannels.map(update => {
      this.dataSource.map(category => {
        category.Channels = category.Channels.filter(c => c.Id !== update.Id);
      });
    });
  }

  private toggleCategoryForChannels(categoryName: string) {
    let arrowDiv = document.getElementById('arrow_' + categoryName);

    if (arrowDiv.innerHTML.includes('arrow_right')) {
      //arrowDiv.innerHTML = '<mat-icon class="menu-icon" style="padding-right: 0px;">arrow_drop_down</mat-icon>';
      arrowDiv.innerHTML = '<span class="material-icons menu-icon" style="padding-right: 10px; vertical-align: middle;">arrow_drop_down</span>';
      document.getElementById('channel_' + categoryName).style.display = 'block';
    }
    else {
      //arrowDiv.innerHTML = '<mat-icon class="menu-icon" style="padding-right: 0px;">arrow_right</mat-icon>';
      arrowDiv.innerHTML = '<span class="material-icons menu-icon" style="padding-right: 10px; vertical-align: middle;">arrow_right</span>';
      document.getElementById('channel_' + categoryName).style.display = 'none';
    }
  }
}  